(() => {
  'use strict';
  // Validate the link format only. Public access is confirmed by the customer,
  // then checked by the print team; no customer design is fetched in the browser.
  const isValid = (value) => {
    try {
      const link = String(value).trim();
      if (!/^https:\/\/[^/?#]/i.test(link) || /[\s\\]/.test(link)) return false;
      const url = new URL(link);
      return url.protocol === 'https:' && Boolean(url.hostname) && !url.username && !url.password;
    } catch (_) {
      return false;
    }
  };
  window.DiaristDesignLink = Object.freeze({ isValid });
  if (customElements.get('diarist-design-link')) return;
  customElements.define('diarist-design-link', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.input = this.querySelector('input[type="url"]');
      this.error = this.querySelector('[role="alert"]');
      if (!this.form || !this.input) return;
      this.abort?.abort();
      this.abort = new AbortController();
      this.form.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal: this.abort.signal });
      this.input.addEventListener('input', () => {
        this.input.setCustomValidity('');
        this.input.removeAttribute('aria-invalid');
        this.error.hidden = true;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
    validate() {
      this.input.value = this.input.value.trim();
      const invalid = this.input.value !== '' && !isValid(this.input.value);
      const message = invalid ? this.dataset.invalidMessage : '';
      this.input.setCustomValidity(message);
      this.input.setAttribute('aria-invalid', String(invalid));
      this.error.textContent = message;
      this.error.hidden = !invalid;
      return this.form.reportValidity();
    }
  });
})();

